import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import {
  ApiError,
  ApiResult,
  ExtendedApiResult,
} from 'common/repositories/common.model';

import {
  getCruisesInput,
  getCruiseInput,
  CruiseLiteModel,
  CruiseModel,
} from './model';

export function useGetCruises(
  input?: getCruisesInput,
  options?: UseQueryOptions<ExtendedApiResult<CruiseLiteModel[]>, ApiError>,
): UseQueryResult<ExtendedApiResult<CruiseLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['getCruises', input?.params],
      () =>
        QueryFetchFunction({
          url: 'cruises',
          params: input?.params,
        }),
      options,
    ),
    CruiseLiteModel,
  );
}

export function useGetCruise(
  input?: getCruiseInput,
  options?: UseQueryOptions<ApiResult<CruiseModel>, ApiError>,
): UseQueryResult<ApiResult<CruiseModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['getCruise', input?.id],
      () => QueryFetchFunction({ url: `cruises/${input?.id}` }),
      options,
    ),
    CruiseModel,
  );
}

export function getCruisesKey(input?: getCruisesInput) {
  return ['getCruises', input?.params];
}

export function getCruiseKey(input?: getCruiseInput) {
  return ['getCruise', input?.id];
}
